export default "__VITE_ASSET__CwJlIx_q__"